import { render } from "./add-membership.vue?vue&type=template&id=6740fa5b"
import script from "./add-membership.vue?vue&type=script&lang=js"
export * from "./add-membership.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__